import { mapDTO } from '@twistezo/ts-dto-mapper'

import { secondsToMilliseconds } from 'utils/number'
import { Schema } from '../../../schema'
import { Variables } from './types'

type From = Schema
type To = Pick<Variables, 'duration' | 'jsdelivrEnabled' | 'vastUrl'>

export const toDTO = (from: From): To =>
  mapDTO<From, To>({ from }).transform((schema: From): To => {
    const { duration, jsdelivrEnabled, vastUrl } = schema

    return {
      duration: secondsToMilliseconds(duration),
      jsdelivrEnabled,
      vastUrl,
    }
  })
